export const communityBreadcrumbTranslations = {
    en: {
        home: "Home",
        community: "Community",
    },
    pt: {
        home: "Início",
        community: "Comunidade",
    },
};

export const communityFeedTranslations = {
    en: {
        pageHeading: "Community",
        heading: "Groups",
        allLanguages: "All Languages",
        noGroups: "No groups available for the selected language.",
    },
    pt: {
        pageHeading: "Comunidade",
        heading: "Grupos",
        allLanguages: "Todos os idiomas",
        noGroups: "Nenhum grupo disponível para o idioma selecionado.",
    },
};

export const localEventsTranslations = {
    pt: {
        heading: "Eventos Locais",
        noEventsTitle: "Nenhum evento programado",
        noEventsSubtitle: "Volte mais tarde ou siga nossos canais sociais para novidades!",
    },
    en: {
        heading: "Local Events",
        noEventsTitle: "No upcoming events",
        noEventsSubtitle: "Check back later or follow our social channels to stay updated!",
    },
};


export const placesPageTranslations = {
    en: {
        heading: "Places Loved by Our Brazilian Community",
        recommendTitle: "Do you have a place to recommend?",
        recommendSubtitle: "Get in touch with us via WhatsApp and let us know! We’d love to share more community favorites.",
        category: {
            Cafe: "Cafe",
            Market: "Market",
            Restaurant: "Restaurant",
            Place: "Place",
        },
    },
    pt: {
        heading: "Lugares que os brasileiros amam na Alemanha",
        recommendTitle: "Você tem um lugar para recomendar?",
        recommendSubtitle: "Fale com a gente pelo WhatsApp! Adoraríamos compartilhar mais dicas da comunidade.",
        category: {
            Cafe: "Café",
            Market: "Mercado",
            Restaurant: "Restaurante",
            Place: "Local",
        },
    },
};

export const aboutPageTranslations = {
    en: {
        pageTitle: "Welcome to the Genau Hub",
        intro:
            "Finding trusted services and connecting with the right people shouldn’t be a struggle — especially when living far from home. We created this platform to support local businesses and individuals by offering a safe, welcoming space where the Brazilian community in Germany can easily connect with trusted professionals. Every listing is carefully reviewed to ensure quality, authenticity, and reliability — because we believe in quality over quantity. Our goal is to bring together a network of verified professionals in one place, making it quick and easy to find the help you need. Whether you're looking for a plumber, a tutor, or a community group, we want this platform to simplify your everyday life abroad.",
        valuesTitle: "Our Values",
        values: {
            trust: {
                label: "Trust",
                desc: "Every professional is vetted for quality and credibility.",
            },
            growth: {
                label: "Growth",
                desc: "We champion small businesses and personal development.",
            },
            empathy: {
                label: "Empathy",
                desc: "We understand the challenges of living far from home.",
            },
            inclusion: {
                label: "Inclusion",
                desc: "Everyone deserves access and opportunity.",
            },
        },
        missionTitle: "Our Mission",
        missionParagraphs: [
            "To make it easier to find reliable services, foster a supportive community, amplify local opportunities and events, and empower small professionals to reach the people who need them most.",
            "We hope this space becomes your daily companion — whether you're navigating services, connecting with others, or exploring local life.",
            "At its core, this project is about making life easier, friendlier, and more connected for everyone building a life far from home.",
        ],
        contactTitle: "Get in Touch",
        contactText:
            "Questions, ideas, or want to join us? Reach out anytime — we’d love to hear from you!",
        getListed: "Get Listed Here",
        socialMedia: "Stay connected on Instagram"
    },
    pt: {
        pageTitle: "Bem-vindo ao Genau Hub",
        intro:
            "Encontrar serviços confiáveis e se conectar com as pessoas certas não deveria ser uma dificuldade — especialmente quando se vive longe de casa. Criamos esta plataforma para apoiar negócios locais e profissionais autônomos, oferecendo um espaço seguro e acolhedor onde a comunidade brasileira na Alemanha possa se conectar facilmente com profissionais de confiança. Cada perfil é cuidadosamente revisado para garantir qualidade, autenticidade e confiabilidade — porque acreditamos em qualidade acima de quantidade. Nosso objetivo é reunir uma rede de profissionais verificados em um só lugar, tornando rápido e fácil encontrar a ajuda que você precisa. Seja procurando um encanador, um professor particular ou um grupo comunitário, queremos que esta plataforma facilite sua vida cotidiana no exterior.",
        valuesTitle: "Nossos Valores",
        values: {
            trust: {
                label: "Confiança",
                desc: "Todo profissional é verificado quanto à qualidade e credibilidade.",
            },
            growth: {
                label: "Crescimento",
                desc: "Apoiamos pequenos negócios e o desenvolvimento pessoal.",
            },
            empathy: {
                label: "Empatia",
                desc: "Entendemos os desafios de viver longe de casa.",
            },
            inclusion: {
                label: "Inclusão",
                desc: "Todos merecem acesso e oportunidades.",
            },
        },
        missionTitle: "Nossa Missão",
        missionParagraphs: [
            "Facilitar o acesso a serviços confiáveis, fortalecer uma comunidade de apoio, amplificar oportunidades e eventos locais, e empoderar pequenos profissionais a alcançarem as pessoas que mais precisam deles.",
            "Esperamos que este espaço se torne seu companheiro diário — seja para encontrar serviços, se conectar com outras pessoas ou explorar a vida local.",
            "No fundo, este projeto é sobre tornar a vida mais fácil, mais acolhedora e mais conectada para todos que estão construindo uma vida longe de casa.",
        ],
        contactTitle: "Fale com a gente",
        contactText:
            "Dúvidas, ideias ou quer participar? Fale com a gente — vamos adorar conversar!",
        getListed: "Cadastre seu serviço",
        socialMedia: "Acompanhe a gente no Instagram"
    },
};

export const registerPageTranslations = {
  en: {
    title: "Join Our Community",
    subtitle: "Are you a Professional offering a service in Germany? Submit your details and get discovered by our growing community!",
    tipsTitle: "Tips for a Great Submission",
    tips: [
      "Provide your full name or business name",
      "Upload a clear profile picture or send it to hello.genauhub@gmail.com",
      "Add your phone number and email",
      "Share your Instagram, Facebook, or website (optional)",
      "Add a short description of your service",
      "Choose the right category for your service",
      "Optionally add your price range or rates",
      "Add your city or region (e.g. Berlin, Hamburg)",
      "Include your service area (online, local delivery, etc.)",
      "Specify your availability and working hours",
      "List the languages you speak (e.g. Portuguese, German, English)",
    ],
  },
  pt: {
    title: "Participe da nossa Comunidade",
    subtitle: "Você é um profissional oferecendo serviços na Alemanha? Cadastre-se e seja descoberto por nossa comunidade!",
    tipsTitle: "Dicas para um bom cadastro",
    tips: [
      "Informe seu nome completo ou nome do negócio",
      "Adicione uma foto de perfil clara ou envie para hello.genauhub@gmail.com",
      "Inclua telefone e e-mail para contato",
      "Compartilhe seu Instagram, Facebook ou site (opcional)",
      "Adicione uma descrição curta do seu serviço",
      "Escolha a categoria correta para seu serviço",
      "Adicione sua faixa de preço (opcional)",
      "Adicione sua cidade ou região (ex: Berlin, Hamburg)",
      "Informe sua área de atendimento (online, entregas, etc.)",
      "Especifique sua disponibilidade e horários de trabalho",
      "Liste os idiomas que você fala (ex: português, alemão, inglês)",
    ],
  },
};

export const registerStepsTranslations = {
  en: {
    title: "How It Works",
    steps: [
      {
        title: "Contact Us",
        desc: "Send your name, contact, and a short description of your service.",
      },
      {
        title: "We Verify",
        desc: "We’ll review your info and confirm or request clarification.",
      },
      {
        title: "You're Listed",
        desc: "Your profile goes live for the community to discover.",
      },
    ],
  },
  pt: {
    title: "Como Funciona",
    steps: [
      {
        title: "Fale com a gente",
        desc: "Envie seu nome, contato e uma descrição do seu serviço.",
      },
      {
        title: "Verificamos",
        desc: "Vamos revisar suas informações e confirmar ou solicitar ajustes.",
      },
      {
        title: "Perfil Publicado",
        desc: "Seu perfil estará disponível para a comunidade encontrar.",
      },
    ],
  },
};

export const registerFormTranslations = {
  en: {
    nameLabel: "Full Name",
    namePlaceholder: "Enter your full name",
    emailLabel: "Contact Email",
    emailPlaceholder: "example@email.com",
    phoneLabel: "Phone Number",
    phonePlaceholder: "+49 12345-6789",
    instagramLabel: "Instagram",
    instagramPlaceholder: "@username",
    facebookLabel: "Facebook",
    facebookPlaceholder: "facebook.com/username",
    serviceTitleLabel: "Service Title",
    serviceTitlePlaceholder: "e.g., Babysitter, Portuguese Teacher, House Cleaner",
    serviceDescriptionLabel: "Service Description",
    serviceDescriptionPlaceholder: "Briefly describe what you offer",
    categoryLabel: "Service Category",
    categoryPlaceholder: "Cleaning, Childcare, Teaching, etc.",
    priceRangeLabel: "Price Range",
    priceRangePlaceholder: "Optional",
    cityLabel: "City or Region",
    cityPlaceholder: "e.g., Berlin, Hamburg",
    serviceAreaLabel: "Service Area",
    serviceAreaPlaceholder: "Online or local service range",
    availabilityLabel: "Availability",
    availabilityPlaceholder: "Days and hours or 'Flexible'",
    languagesLabel: "Languages Spoken",
    languagesPlaceholder: "Portuguese, German, English...",
    messageLabel: "Message",
    messagePlaceholder: "Write your message",
    profilePicNote: "Please send your profile picture to",
    submitButton: "Send",
    consentLabel:
      "I consent to the processing and public publication of my submitted data according to the Privacy Policy.",
    consentHelp:
      "You can withdraw consent at any time by emailing hello.genauhub@gmail.com.",
    successMessage: "✅ Thanks! We’ll be in touch.",
    errorMessage: "❌ Something went wrong. Please try again.",
    validation: {
      nameRequired: "Name is required.",
      emailRequired: "Email is required.",
      emailInvalid: "Invalid email format.",
      messageRequired: "Message is required.",
      consentRequired: "Consent is required.",
    },
  },

  pt: {
    nameLabel: "Nome completo",
    namePlaceholder: "Digite seu nome completo",
    emailLabel: "E-mail de contato",
    emailPlaceholder: "exemplo@email.com",
    phoneLabel: "Telefone",
    phonePlaceholder: "+49 12345-6789",
    instagramLabel: "Instagram",
    instagramPlaceholder: "@usuario",
    facebookLabel: "Facebook",
    facebookPlaceholder: "facebook.com/usuario",
    serviceTitleLabel: "Título do serviço",
    serviceTitlePlaceholder: "Ex: Vendas, Professora de Português, Faxineira",
    serviceDescriptionLabel: "Descrição do serviço",
    serviceDescriptionPlaceholder: "Descreva brevemente o que você oferece",
    categoryLabel: "Categoria do serviço",
    categoryPlaceholder: "Limpeza, Cuidado infantil, Ensino, etc.",
    priceRangeLabel: "Faixa de preço",
    priceRangePlaceholder: "Opcional",
    cityLabel: "Cidade ou Região",
    cityPlaceholder: "Ex: Berlim, Hamburgo",
    serviceAreaLabel: "Área de atendimento",
    serviceAreaPlaceholder: "Online ou atendimento local",
    availabilityLabel: "Disponibilidade",
    availabilityPlaceholder: "Dias e horários ou 'Flexível'",
    languagesLabel: "Idiomas falados",
    languagesPlaceholder: "Português, Alemão, Inglês...",
    messageLabel: "Mensagem",
    messagePlaceholder: "Escreva sua mensagem",
    profilePicNote: "Por favor, envie sua foto de perfil para",
    submitButton: "Enviar",
    consentLabel:
      "Eu concordo com o tratamento e a publicação pública dos dados enviados, conforme a Política de Privacidade.",
    consentHelp:
      "Você pode revogar o consentimento a qualquer momento pelo e-mail hello.genauhub@gmail.com.",
    successMessage: "✅ Obrigado! Entraremos em contato.",
    errorMessage: "❌ Algo deu errado. Tente novamente.",
    validation: {
      nameRequired: "Nome é obrigatório.",
      emailRequired: "E-mail é obrigatório.",
      emailInvalid: "Formato de e-mail inválido.",
      messageRequired: "Mensagem é obrigatória.",
      consentRequired: "O consentimento é obrigatório.",
    },
  },
};

export const faqTranslations = {
  en: [
    {
      question: "What is GenauHub and who is it for?",
      answer:
        "GenauHub is a platform that connects Brazilians in Germany with trusted service providers and community groups.",
    },
    {
      question: "How can I register my service on GenauHub?",
      answer:
        'You can register your service by filling out the registration form on the "Register a Service" page.',
    },
    {
      question: "Is there a cost to join or publish a service?",
      answer: "No! Posting your service or joining groups is completely free.",
    },
    {
      question: "What types of services are accepted?",
      answer:
        "We welcome professionals in cleaning, sales, pet care, teaching, event planning, beauty, and more.",
    },
    {
      question: "Can I edit or update my listing after submission?",
      answer:
        "Yes. You’ll receive an email link where you can request edits or updates to your profile.",
    },
    {
      question: "How do I join a WhatsApp group from the community section?",
      answer:
        "Simply click on a group you’re interested in and follow the “Join” link to WhatsApp.",
    },
    {
      question: "How are professionals verified?",
      answer:
        "All submissions are manually reviewed before being published to ensure authenticity and relevance.",
    },
    {
      question: "What languages do service providers speak?",
      answer:
        "Most providers speak Portuguese, and many also speak German and English. Each profile lists spoken languages.",
    },
    {
      question: "How can I leave a review or feedback?",
      answer:
        "You can share your experience by contacting us directly or leaving comments on the provider’s social media.",
    },
    {
      question: "I have a problem or suggestion. How can I contact support?",
      answer:
        'Use the "Feedbacks" button available on the bottom of the site to reach out.',
    },
  ],
  pt: [
    {
      question: "O que é o GenauHub e para quem é?",
      answer:
        "GenauHub é uma plataforma que conecta brasileiros na Alemanha com prestadores de serviços e grupos da comunidade.",
    },
    {
      question: "Como posso cadastrar meu serviço no GenauHub?",
      answer:
        'Você pode cadastrar seu serviço preenchendo o formulário na página "Cadastrar um Serviço".',
    },
    {
      question: "Há algum custo para participar ou divulgar um serviço?",
      answer: "Não! Cadastrar o seu serviço ou participar de grupos é totalmente gratuito.",
    },
    {
      question: "Que tipos de serviços são aceitos?",
      answer:
        "Aceitamos profissionais de limpeza, babá, cuidados com animais, ensino, eventos, beleza e muito mais.",
    },
    {
      question: "Posso editar ou atualizar meu perfil depois de enviar?",
      answer:
        "Sim. Você receberá um link por e-mail onde poderá solicitar atualizações ou correções no seu perfil.",
    },
    {
      question: "Como entro em um grupo do WhatsApp da comunidade?",
      answer:
        "Basta clicar em um grupo do seu interesse e seguir o link “Entrar” para o WhatsApp.",
    },
    {
      question: "Como os profissionais são verificados?",
      answer:
        "Todas as submissões são revisadas manualmente antes de serem publicadas para garantir autenticidade e relevância.",
    },
    {
      question: "Quais idiomas os prestadores de serviço falam?",
      answer:
        "A maioria fala português, e muitos também falam alemão e inglês. Cada perfil informa os idiomas.",
    },
    {
      question: "Como posso deixar um feedback ou avaliação?",
      answer:
        "Você pode compartilhar sua experiência entrando em contato diretamente ou comentando nas redes sociais do profissional.",
    },
    {
      question: "Tenho um problema ou sugestão. Como entro em contato?",
      answer:
        'Use o botão "Feedbacks" no final do site para entrar em contato conosco.',
    },
  ],
};

export const servicesSlugTranslations = {
  pt: {
    noProfessionalsTitle: "Nenhum profissional encontrado",
    noProfessionalsDescription:
      "Não encontramos nenhum serviço listado para esta categoria no momento. Volte mais tarde ou registre seu serviço para aparecer aqui.",
    register: "Cadastrar um serviço",
  },
  en: {
    noProfessionalsTitle: "No professionals found",
    noProfessionalsDescription:
      "We couldn't find any listings for this category right now. Please check back later or register your service to be featured here.",
    register: "Register a Service",
  },
};